export default __webpack_public_path__ + "static/media/poly-bun.31ff6305.webp";